import { render } from "./Slide.vue?vue&type=template&id=a97c3c5c"
import script from "./Slide.vue?vue&type=script&lang=js"
export * from "./Slide.vue?vue&type=script&lang=js"

import "./Slide.vue?vue&type=style&index=0&id=a97c3c5c&lang=css"

import exportComponent from "/Users/romuloreis/Documents/CakeCherries/mural-viewer-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__